export default __webpack_public_path__ + "static/media/Setting.470a8994.svg";